import React, { useEffect, useState } from 'react'
import { leaV3API, DashboardData } from '../api/leaV3.api'

export const DashboardView: React.FC = () => {
  const [data, setData] = useState<DashboardData | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    leaV3API
      .getDashboard()
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.message || 'Failed to load dashboard'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-4 text-gray-500">Chargement…</div>
  if (error) return <div className="p-4 text-red-600">Erreur : {error}</div>
  if (!data) return null

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Affaires actives" value={data.affaires.active} sub={`${data.affaires.total} total`} />
        <StatCard label="Timeouts" value={data.timeouts.total} />
        <StatCard label="Prêts à process" value={data.timeouts.expired} highlight />
        <StatCard label="En attente" value={data.timeouts.pending} />
      </div>

      <section>
        <h3 className="font-semibold mb-2 text-gray-700">Distribution par catégorie / ladder slot</h3>
        <table className="min-w-full bg-white border border-gray-200 text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="px-3 py-2 text-left">Catégorie</th>
              <th className="px-3 py-2 text-left">Ladder slot</th>
              <th className="px-3 py-2 text-right">Affaires</th>
            </tr>
          </thead>
          <tbody>
            {data.ladder_breakdown.map((r, i) => (
              <tr key={i} className="border-t border-gray-100">
                <td className="px-3 py-2">{r.category}</td>
                <td className="px-3 py-2 font-mono text-xs text-gray-600">{r.ladder_slot || '—'}</td>
                <td className="px-3 py-2 text-right">{r.n}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h3 className="font-semibold mb-2 text-gray-700">Distribution des routes (trigger × unit)</h3>
        <table className="min-w-full bg-white border border-gray-200 text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="px-3 py-2 text-left">Trigger</th>
              <th className="px-3 py-2 text-left">Unit</th>
              <th className="px-3 py-2 text-right">Routes</th>
              <th className="px-3 py-2 text-right">Min delay</th>
              <th className="px-3 py-2 text-right">Max delay</th>
            </tr>
          </thead>
          <tbody>
            {data.route_distribution.map((r, i) => (
              <tr key={i} className="border-t border-gray-100">
                <td className="px-3 py-2">{r.trigger}</td>
                <td className="px-3 py-2">{r.unit}</td>
                <td className="px-3 py-2 text-right">{r.n}</td>
                <td className="px-3 py-2 text-right">{r.min_delay}</td>
                <td className="px-3 py-2 text-right">{r.max_delay}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  )
}

const StatCard: React.FC<{ label: string; value: number; sub?: string; highlight?: boolean }> = ({
  label,
  value,
  sub,
  highlight
}) => (
  <div className={`rounded-lg p-4 border ${highlight ? 'border-[#ef5343] bg-[#fff1ef]' : 'border-gray-200 bg-white'}`}>
    <div className="text-xs text-gray-500 uppercase tracking-wide">{label}</div>
    <div className={`text-2xl font-bold ${highlight ? 'text-[#ef5343]' : 'text-gray-800'}`}>{value}</div>
    {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
  </div>
)
